import { schema } from "normalizr";

const segmentSchema = new schema.Entity("segments", {});

export default segmentSchema;



// WEBPACK FOOTER //
// ./src/schemas/segment.js